export const populateNotifications = actionName => [
  `NOTIFY_${actionName}_PENDING`,
  `NOTIFY_${actionName}_SUCCESS`,
  `NOTIFY_${actionName}_ERROR`,
];

export const populateAsync = actionName => [
  `${actionName}`,
  `${actionName}_PENDING`,
  `${actionName}_FULFILLED`,
  `${actionName}_REJECTED`,
];
